export default {"src":"/_next/static/media/mqSecurity.17e02457.svg","height":352,"width":427};